import { OnOffSwitch, OnOffSwitchSize } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { useUpdateAccountSignalSettingsMutation } from "app/pages/sales-intelligence/sub-modules/signals/query/mutations/useUpdateAccountSignalSettingsMutation";
import { useAccountSignalSettingsQuery } from "app/pages/sales-intelligence/sub-modules/signals/query/useAccountSignalSettingsQuery";

import { StyledDescription, StyledToggleRow } from "./styles";

interface IProps {
    onToggle?: (isEnabled: boolean) => void;
}

export const AllowUserCustomizationToggle = ({ onToggle }: IProps) => {
    const { data, isLoading } = useAccountSignalSettingsQuery();
    const { mutate } = useUpdateAccountSignalSettingsMutation();

    const isEnabled = data?.allowUserCustomization ?? false;

    const handleToggle = () => {
        onToggle?.(!isEnabled);

        mutate({ allowUserCustomization: !isEnabled });
    };

    if (isLoading) {
        return null;
    }

    return (
        <StyledToggleRow data-automation="signals-management-allow-customization-toggle">
            <OnOffSwitch
                size={OnOffSwitchSize.medium}
                isSelected={isEnabled}
                onClick={handleToggle}
            />
            <StyledDescription>
                {translate("si.account-signals.management.allow-customization.description")}
            </StyledDescription>
        </StyledToggleRow>
    );
};
